import {
	API_ADMIN_GET_ALL_LOG,
	API_ADMIN_GET_FOLDER_LOG,
	ADMIN_RESET_LOGS,
	API_GET_FOLDER_LOG,
} from 'actions/log.js';

export function adminGetAllLog() {
	return {
		type: API_ADMIN_GET_ALL_LOG,
		payload: {
			request: {
				url: `/admin/logs`,
			},
		},
	};
}

export function adminGetFolderLogs(folderId) {
	return {
		type: API_ADMIN_GET_FOLDER_LOG,
		payload: {
			request: {
				url: `/admin/logs/folder/${folderId}`,
			},
		},
	};
}

export function getFolderLogs(folderId) {
	return {
		type: API_GET_FOLDER_LOG,
		payload: {
			request: {
				url: `/logs/folder/${folderId}`,
			},
		},
	};
}

export function resetLogs() {
	return {
		type: ADMIN_RESET_LOGS
	};
}